export const SET_MOBILE_MENU = 'app/SET_MOBILE_MENU';
export const SET_IS_CREATE_MODAL_SHOWING = 'app/SET_IS_CREATE_MODAL_SHOWING';

export const showMobileMenu = (open = true) => ({
    type: SET_MOBILE_MENU,
    data: !!open
});

export const toggleMobileMenu = () => (dispatch, getState) => {
    const { mobileMenu } = getState().app;
    dispatch(showMobileMenu(!mobileMenu));
};

export const isCreateModalShowing = (value) => ({
    type: SET_IS_CREATE_MODAL_SHOWING,
    data: value
});
